import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    marginTop: '60px',
  },
  sectionTitle: {
    marginBottom: '8px',
  },
  columnReverse: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
    },
  },
  dropdown: {
    '& div, li': {
      fontFamily: 'Roboto',
      fontWeight: 500,
    },
    '& legend': {
      visibility: 'visible',
      lineHeight: '1em',
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: '16px',
    },
  },
}))
